import React, { useEffect, useState, useRef } from "react";
import { fetchTestimonials } from "../API/API";
import { FaLinkedin, FaStar, FaRegStar } from "react-icons/fa";
import "../styles/TestimonialSection.css";

const TestimonialSection = () => {
  const [testimonials, setTestimonials] = useState([]);
  const reviewRefs = useRef([]);
  const trackRef = useRef(null);
  const isDragging = useRef(false);
  const startX = useRef(0);
  const scrollLeftStart = useRef(0);

  const getImageUrl = (url) => {
    if (!url) return "/images/Testimonial.png";
    if (url.startsWith("http")) return url;
    return `https://inslitit.com${url}`;
  };

  const renderStars = (rating) => {
    const filledStars = Math.round(rating || 0);
    return (
      <div className="testimonial-stars">
        {[...Array(5)].map((_, i) =>
          i < filledStars ? (
            <FaStar key={i} className="star filled" />
          ) : (
            <FaRegStar key={i} className="star empty" />
          )
        )}
      </div>
    );
  };

  const getFallbackTestimonials = () => [
    {
      name: "Priya Malvi",
      position: "AI Engineer",
      linkedin: "https://linkedin.com/in/example-priya",
      rating: 5,
      review: "Working with Sharat has truly been a transformative experience...",
      profile_picture: null,
    },
    {
      name: "Rahul Mehta",
      position: "Data Scientist",
      linkedin: "https://linkedin.com/in/example-rahul",
      rating: 4,
      review: "Sharat is one of the most impactful mentors...",
      profile_picture: null,
    },
  ];

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await fetchTestimonials();
        const data = response.data;
        setTestimonials(Array.isArray(data) && data.length > 0 ? data : getFallbackTestimonials());
      } catch (error) {
        console.error("Error fetching testimonials:", error);
        setTestimonials(getFallbackTestimonials());
      }
    };
    getData();
  }, []);

  useEffect(() => {
    reviewRefs.current = reviewRefs.current.slice(0, testimonials.length * 2);
  }, [testimonials]);

  // Smooth auto scroll with seamless loop
  // useEffect(() => {
  //   const track = trackRef.current;
  //   if (!track) return;

  //   let animationId;

  //   const scroll = () => {
  //     if (track.scrollLeft >= track.scrollWidth / 2) {
  //       track.scrollLeft = 0;
  //     } else {
  //       track.scrollLeft += 1;
  //     }
  //     animationId = requestAnimationFrame(scroll);
  //   };

  //   animationId = requestAnimationFrame(scroll);

  //   return () => cancelAnimationFrame(animationId);
  // }, [testimonials]);

  // Drag to scroll (mouse and touch)
  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    const startDrag = (e) => {
      isDragging.current = true;
      track.classList.add("dragging");
      startX.current = e.pageX || e.touches[0].pageX;
      scrollLeftStart.current = track.scrollLeft;
    };

    const duringDrag = (e) => {
      if (!isDragging.current) return;
      const x = e.pageX || e.touches[0].pageX;
      const walk = x - startX.current;
      track.scrollLeft = scrollLeftStart.current - walk;
    };

    const endDrag = () => {
      isDragging.current = false;
      track.classList.remove("dragging");
    };

    track.addEventListener("mousedown", startDrag);
    track.addEventListener("mousemove", duringDrag);
    track.addEventListener("mouseup", endDrag);
    track.addEventListener("mouseleave", endDrag);

    track.addEventListener("touchstart", startDrag, { passive: true });
    track.addEventListener("touchmove", duringDrag, { passive: true });
    track.addEventListener("touchend", endDrag);

    return () => {
      track.removeEventListener("mousedown", startDrag);
      track.removeEventListener("mousemove", duringDrag);
      track.removeEventListener("mouseup", endDrag);
      track.removeEventListener("mouseleave", endDrag);
      track.removeEventListener("touchstart", startDrag);
      track.removeEventListener("touchmove", duringDrag);
      track.removeEventListener("touchend", endDrag);
    };
  }, []);

  return (
    <div className="testimonial-section">
      <h2 className="testimonial-title">Reviews From Our Users</h2>
      <div className="testimonial-container">
        <div className="testimonial-track" ref={trackRef}>
          {[...testimonials, ...testimonials].map((testimonial, index) => (
            <div
              className="testimonial-card"
              key={index}
              onMouseLeave={() => {
                const ref = reviewRefs.current[index];
                if (ref) ref.scrollTop = 0;
              }}
            >
              <div className="testimonial-top">
                <img
                  src={getImageUrl(testimonial.profile_picture)}
                  alt={testimonial.name}
                  className="testimonial-image"
                />
                <div className="testimonial-name-role">
                  <p className="testimonial-name">{testimonial.name}</p>
                  <div className="testimonial-role-line">
                    <p className="testimonial-role">{testimonial.position}</p>
                    {testimonial.linkedin && (
                      <a
                        href={testimonial.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="linkedin-icon"
                      >
                        <FaLinkedin />
                      </a>
                    )}
                  </div>
                </div>
              </div>

              {renderStars(testimonial.rating)}

              <div
                className="testimonial-feedback scroll-on-hover"
                ref={(el) => (reviewRefs.current[index] = el)}
              >
                “{testimonial.review}”
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TestimonialSection;
